import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { useCatalogFetchers } from "@/shared/catalogs/hooks/useCatalogs";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchParts = ({ setIsLoading, setError }: Props) => {
	const {
		actions: { setListAllParts },
	} = useTemplatesContext();
	const { fetchPartsInventory } = useCatalogFetchers();

	return async () => {
		setIsLoading(true);
		try {
			setListAllParts(await fetchPartsInventory());
		} catch (e: any) {
			setError(e?.message || "Error fetching the parts inventory");
		} finally {
			setIsLoading(false);
		}
	};
};
